import React from 'react';
import * as S from './Options.styled';
import { OptionsItem } from './OptionsItem/OptionsItem';
export const Options = ({ children, borderless, gap = 0 }) => {
    return (React.createElement(S.Container, { "data-testid": "Options", "$borderless": borderless, "$gap": gap }, children));
};
Options.Item = OptionsItem;
